import { useDispatch, useSelector } from "react-redux";
import Modal from "../UI/Modal";
import {
  closeAccionFormModal,
  openAccionViewModal,
} from "../../store/reducers/fortalezas/fortalezas.reducer";
import { useEffect, useState } from "react";
import {
  createAccionDesarrolloThunk,
  updateAccionDesarrolloThunk,
  getAccionesDesarrolloThunk,
  getAccionDesarrolloByIdThunk,
} from "../../store/reducers/fortalezas/fortalezas.thunks";
import Loader from "../UI/Loader";
import Alert from "../UI/Alert";
import Select2 from "../UI/Select2";
import { getAreasSelectoresService } from "../../services/fortalezas/fortalezas.service";
import { toast } from "react-toastify";

const AccionFormModal = () => {
  const dispatch = useDispatch();
  const {
    accionFormModalOpen,
    accionFormMode,
    selectedAccion,
    accionFormLoading,
    accionFormError,
    accionesPage,
    accionesSearch,
    accionesFilterArea,
    accionesFilterTalento,
  } = useSelector((state) => state.fortalezas);

  const [formData, setFormData] = useState({
    frase: "",
    area: null,
    talento: null,
  });

  useEffect(() => {
    if (accionFormMode === "edit" && selectedAccion) {
      setFormData({
        frase: selectedAccion.frase || "",
        area: selectedAccion.area || null,
        talento: selectedAccion.talento || null,
      });
    } else {
      setFormData({
        frase: "",
        area: null,
        talento: null,
      });
    }
  }, [accionFormMode, selectedAccion, accionFormModalOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchAreas = async (searchTerm) => {
    const response = await getAreasSelectoresService(searchTerm);
    return response.map((item) => ({
      id: item.id,
      label: item.label || item.area,
    }));
  };

  const handleAreaChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      area: value || null,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      ...formData,
    };

    if (accionFormMode === "create") {
      const result = await dispatch(createAccionDesarrolloThunk(payload));
      if (result.meta.requestStatus === "fulfilled") {
        const createdId = result.payload?.data?.id || result.payload?.id;
        dispatch(
          getAccionesDesarrolloThunk({
            page: 1,
            search: "",
            area: "",
            talento: "",
          })
        );
        toast.success("Acción creada exitosamente");
        if (createdId) {
          await dispatch(getAccionDesarrolloByIdThunk(createdId));
          dispatch(openAccionViewModal());
        }
      }
    } else {
      const result = await dispatch(
        updateAccionDesarrolloThunk({
          id: selectedAccion.id,
          payload,
        })
      );
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(
          getAccionesDesarrolloThunk({
            page: accionesPage,
            search: accionesSearch,
            area: accionesFilterArea,
            talento: accionesFilterTalento,
          })
        );
        toast.success("Acción actualizada exitosamente");
        await dispatch(getAccionDesarrolloByIdThunk(selectedAccion.id));
        dispatch(openAccionViewModal());
      }
    }
  };

  return (
    <Modal
      open={accionFormModalOpen}
      onClose={() => dispatch(closeAccionFormModal())}
      title={
        accionFormMode === "create"
          ? "Crear nueva acción de desarrollo"
          : "Editar acción de desarrollo"
      }
      size="lg"
    >
      {accionFormLoading ? (
        <Loader
          center
          type="dots"
          text={
            accionFormMode === "create"
              ? "Creando acción..."
              : "Actualizando acción..."
          }
        />
      ) : (
        <form onSubmit={handleSubmit}>
          {accionFormError && <Alert message={accionFormError} variant="error" />}

          <div className="mb-3">
            <label className="form-label fw-medium">
              Acción / Frase <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control"
              name="frase"
              value={formData.frase}
              onChange={handleChange}
              placeholder="Ingrese la acción o frase"
              rows="4"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-medium">
              Área de desarrollo <span className="text-danger">*</span>
            </label>
            <Select2
              value={formData.area}
              onChange={handleAreaChange}
              fetchOptions={fetchAreas}
              placeholder="Selecciona un área"
              isClearable
            />
          </div>

          <div className="d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => dispatch(closeAccionFormModal())}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              {accionFormMode === "create" ? "Crear" : "Guardar cambios"}
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default AccionFormModal;
